module.exports = __webpack_public_path__ + "static/media/image_15.65577c00.jpeg";